import React, { useEffect } from 'react';
import { MdChat, MdChatBubble } from 'react-icons/md';
import { Container, Sponsor, SponsorGrid } from './styles';
import { Button } from '../../components/Button/styles';
import Sponsors from '../SponsorsPage';
import Particles from 'react-particles-js';
import ImageSliderBackground from '../../components/ImageBackgroundSlider';
import RodapeLP from '../Home/modules/RodapeLP';
import Whatsapp from '../../components/Whatsapp';
import { ContactIcons } from 'src/components/MenuOld';
import { getYear } from 'date-fns';
import Paginas from '../../PagesApplication/HomeApplication/modules/Paginas';

const FooterLayout: React.FC = ({ children }) => {
  return (<> 
 

  <Paginas hash='footer' project_id='evento' />
  </>
  );
};

export default FooterLayout;
